import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../component/Header';
import SideBar from '../component/SideBar';
import Actions from '../redux/actions';
import AppLoader from '../utils/AppLoader';
import PaginationComponenent from '../component/Pagination';
import Constants, { LIMIT, THREEDSCRIPT } from '../utils/Constants';
import { toast } from 'react-toastify';
import RoutePath from '../utils/routes/RoutePath';
import ARProductsList from '../component/ARProductsList';
import VendorService from '../component/VendorService';
import { getSavedPage, setSavedPage } from '../utils/paginationState';

const PAGINATION_KEY = 'vendor-service-list';

class VendorServiceList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            pageNumber: getSavedPage(PAGINATION_KEY),
            totalItem: '',
            isVendor: false,
            isCopied: false,
            searchText: '',
        }
    }
    componentDidMount() {
        const Agent = this.props.match.path.split('/')
        if (Agent[2] === "service" && Agent[1] === "admin") {
            this.setState({ isVendor: true })
        } else {
            this.setState({ isVendor: false })
        }
        this.getVendorAllServiceList(false)
    }

    getVendorAllServiceList = (isUpdate) => {
        let params = {
            limit: LIMIT,
            pageNumber: this.state.pageNumber - 1
        }
        const callback = (response) => {
            if (response) {
                this.setState({ totalItem: response.response.totalItems })
            }
        }
        this.props.getVendorServiceList(params, callback)
    }
    onChangePagination = (pageNumber) => {
        let params = {
            pageNumber: (pageNumber - 1),
            limit: LIMIT
        }
        this.props.getVendorServiceList(params, '', false)
        setSavedPage(PAGINATION_KEY, pageNumber);
        this.setState({ pageNumber: pageNumber })
    }
    updateStatus = (id, active) => {
        const updateParams = {
            id,
            isActive: active ? 0 : 1
        }
        const callback = (response) => {
            if (response.response_code === 0) {
                toast.success(Constants.UPDATED_SUCCESSFULLY)
                this.getVendorAllServiceList(true)
            }
            else {
                toast.error(response.response_message)
            }
        }
        this.props.updateVendorService(updateParams, callback, false)
    }
    deleteVendorService = (id) => {
        const isConfirmed = window.confirm("Are you sure you want to permanently delete this service? All room mappings and related call records for this service will also be deleted.");
        if (!isConfirmed) {
            return;
        }
        const callback = (response) => {
            if (response.response_code === 0) {
                toast.success("Service deleted successfully")
                this.getVendorAllServiceList(true)
            }
            else {
                toast.error(response.response_message)
            }
        }
        this.props.deleteVendorService({ id }, callback)
    }
    addVendorService = () => {
        this.props.history.push(RoutePath.VENDOR_SERVICE_ADD)
    }
    clearSearch = () => {
        this.setState({ searchText: '' })
    }
    handleSearchChange = (e) => {
        this.setState({ searchText: e.target.value, pageNumber: 1 })
    }
    render() {
        const { pageNumber, isVendor, searchText } = this.state;
        const { getVendorRoomService = {} } = this.props
        const { isLoading, vendorServiceListData } = getVendorRoomService
        const search = (searchText || "").trim().toLowerCase();
        const filteredServices = (vendorServiceListData?.services || []).filter((service) => {
            if (!search) return true;
            const serviceName = (service?.serviceName || "").toLowerCase();
            const email = (service?.User?.email || "").toLowerCase();
            return serviceName.includes(search) || email.includes(search);
        });
        return (
            <div className="dashboard-screen-part">
                <div className="d-flex p-0">
                    <SideBar />
                    <div className="card-right p-0">
                        <Header />
                        <div className='addButton'>
                            <div className="add-btn">
                                <button className="btn add-item" type="button" onClick={() => this.addVendorService()}><i className="fa-solid fa-plus me-3"></i>Add Service</button>
                            </div>
                            <div className="add-btn search-box">
                                <input
                                    className="form-control search-input"
                                    placeholder="Search by service / email"
                                    value={searchText}
                                    onChange={this.handleSearchChange}
                                />
                                {searchText ? <button type="button" className="search-clear-btn" onClick={this.clearSearch}>x</button> : null}
                            </div>
                        </div>
                        <VendorService serviceList={filteredServices} updateStatus={(id, active) => this.updateStatus(id, active)}
                            deleteService={(id) => this.deleteVendorService(id)}
                            isVendor={isVendor}
                            currentPage={pageNumber} />
                        <div className='page-content'>
                            {
                                vendorServiceListData?.totalItems > (LIMIT - 1) ? <PaginationComponenent currentPage={pageNumber} countValue={vendorServiceListData?.totalItems} onChangeHandle={this.onChangePagination} /> : ''
                            }
                        </div>
                    </div>
                </div>

                {isLoading && <AppLoader />}
            </div>
        );
    }
}

export const mapStateToProps = (state) => {
    return {
        getVendorRoomService: Actions.getVendorRoomService(state)
    }
};
export default withRouter(connect(mapStateToProps, {
    getVendorServiceList: Actions.getVendorServiceList,
    updateVendorService: Actions.updateVendorService,
    deleteVendorService: Actions.deleteVendorService
})(VendorServiceList
));